<template>
  <div class="flex flex-row">
    <div
      class="p-1 w-1 h-1 mr-0.5 rounded-full animate-bounce first-circle"
      :class="[mode === 'dark' ? 'bg-brand-mid-gray' : 'bg-brand-light-gray']"
    ></div>
    <div
      class="p-1 w-1 h-1 mr-0.5 rounded-full animate-bounce second-circle"
      :class="[mode === 'dark' ? 'bg-brand-mid-gray' : 'bg-brand-light-gray']"
    ></div>
    <div
      class="p-1 w-1 h-1 rounded-full animate-bounce third-circle"
      :class="[mode === 'dark' ? 'bg-brand-mid-gray' : 'bg-brand-light-gray']"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    mode: {
      type: String,
      default: "dark"
    }
  }
}
</script>
<style lang="scss" scoped>
.first-circle {
  animation-delay: 0.1s;
}
.second-circle {
  animation-delay: 0.2s;
}
.third-circle {
  animation-delay: 0.3s;
}
</style>
